import { render, staticRenderFns } from "./PopupNotification.vue?vue&type=template&id=3c010aec&scoped=true"
import script from "./PopupNotification.vue?vue&type=script&lang=ts"
export * from "./PopupNotification.vue?vue&type=script&lang=ts"
import style0 from "./PopupNotification.vue?vue&type=style&index=0&id=3c010aec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c010aec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c010aec')) {
      api.createRecord('3c010aec', component.options)
    } else {
      api.reload('3c010aec', component.options)
    }
    module.hot.accept("./PopupNotification.vue?vue&type=template&id=3c010aec&scoped=true", function () {
      api.rerender('3c010aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/PopupNotification.vue"
export default component.exports